import { COLUMN } from '@yme/atoms/grid/constants';
import { MIN_INDEX_FOR_SECOND_ROW } from '@yme/components/HomePage/components/constants';
import { TEST_RIDE_MAX_CARD } from './constants';
export function isRequestTestRideEmpty(props) {
    return props?.cards?.length === 0 || !props?.header;
}
export const calcMarginBottom = ({ length, isMobileView, isTabletView, isInfiniteDesktopView, index, }) => {
    const currentPosition = index + 1;
    const isMarginForDesktop = isInfiniteDesktopView &&
        length === TEST_RIDE_MAX_CARD &&
        currentPosition < MIN_INDEX_FOR_SECOND_ROW;
    const isMarginForTablet = isTabletView && length >= TEST_RIDE_MAX_CARD - 1 && currentPosition < MIN_INDEX_FOR_SECOND_ROW;
    const isMarginForMobile = isMobileView && currentPosition <= length - 1;
    if (isMarginForDesktop || isMarginForTablet || isMarginForMobile) {
        return '24px';
    }
    return 'auto';
};
export const getColumnNumberForDesktop = (cardsLength) => {
    if (cardsLength !== TEST_RIDE_MAX_CARD) {
        return COLUMN.lg / cardsLength;
    }
    return COLUMN.lg / 2;
};
